export default __webpack_public_path__ + "static/media/EAST2460.34I-34265_-18491_0.739f69cb.jpg";